import { Picture } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import {
  GridBlock,
  LinkBlock,
  SectionDescription,
  SectionLink,
  SectionTextBlock,
  SectionTitle,
} from "./components"

const ImageTextBlock = ({ element }) => (
  <GridBlock display={{ _: "block", tablet: element.display || "block" }}>
    <LinkBlock
      data-lc="image-text-block"
      flex="2"
      order={{ tablet: element.textPosition === "left" ? 2 : 1 }}
      to={element.link}
    >
      <Picture
        alt={element.title}
        fallback={`${sl.config.jewlr_asset_url}images/homepage/jewlr/${element.image}/desktop_2x.jpg`}
        srcSet={[
          {
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/${element.image}/mobile.jpg 767w,
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/${element.image}/mobile_2x.jpg 1534w
              `,
          },
          {
            media: "(min-width: 768px)",
            sizes: "100vw",
            srcSet: `
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/${element.image}/desktop.jpg 767w,
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/${element.image}/desktop_2x.jpg 1534w
              `,
          },
        ]}
      />
    </LinkBlock>
    <SectionTextBlock
      flex="1"
      order={{ tablet: element.textPosition === "left" ? 1 : 2 }}
    >
      <SectionTitle>{element.title}</SectionTitle>
      <SectionDescription>{element.description}</SectionDescription>
      {!element.hidelink && (
        <SectionLink data-lc="image-text-block" to={element.link}>
          Shop Now
        </SectionLink>
      )}
    </SectionTextBlock>
  </GridBlock>
)

ImageTextBlock.propTypes = {
  element: PropTypes.object,
}

export default ImageTextBlock
